<template>
    <div class="notice-rule">
        <mc-operate-bar>
            <template slot="left">
                <div class="mc-search-bar">
                    <div class="mc-search-bar-input">
                        <el-input placeholder="输入站点名称" style="margin-right:10px" v-model="searchParmas.site" @keyup.enter.native="$_getTableList()"></el-input>
                        <el-input placeholder="输入姓名" v-model="searchParmas.username" @keyup.enter.native="$_getTableList()"></el-input>
                    </div>
                    <el-button class="mc-search-bar-btn" type="primary" icon="el-icon-search" size="mini" @click="$_getTableList()"></el-button>
                    <el-button class="mc-search-bar-btn" type="danger" icon="el-icon-close" @click="$_reset()" size="mini"
                        v-if="searchParmas.site||searchParmas.username"></el-button>
                </div>
            </template>
            <template slot="right">
                <el-button type="primary" @click="dialog.serve.methods.open()">新增规则</el-button>
            </template>
        </mc-operate-bar>
        <mc-table ref="mc-table" :table-option="tableOption" v-loading="tableOption.loading">
            <template slot="table-components">
                <el-table-column sortable :prop="tableOption.head[0].prop" :label="tableOption.head[0].label" :width="tableOption.head[0].width"
                    v-if="tableOption.head.length>0"></el-table-column>
                <el-table-column sortable :prop="tableOption.head[1].prop" :label="tableOption.head[1].label" :width="tableOption.head[1].width"
                    v-if="tableOption.head.length>0"></el-table-column>
                <el-table-column sortable :prop="tableOption.head[2].prop" :label="tableOption.head[2].label" :width="tableOption.head[2].width"
                    v-if="tableOption.head.length>0"></el-table-column>
                <el-table-column :prop="tableOption.head[3].prop" :label="tableOption.head[3].label" :width="tableOption.head[3].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span v-if="scope.row.alert_severity == 1">消息</span>
                        <span v-else-if="scope.row.alert_severity == 2">一般</span>
                        <span v-else-if="scope.row.alert_severity == 3">消息，一般</span>
                        <span v-else-if="scope.row.alert_severity == 4">严重</span>
                        <span v-else-if="scope.row.alert_severity == 5">消息，严重</span>
                        <span v-else-if="scope.row.alert_severity == 6">一般，严重</span>
                        <span v-else-if="scope.row.alert_severity == 7">消息，一般，严重</span>
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[4].prop" :label="tableOption.head[4].label" :width="tableOption.head[4].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span v-if="scope.row.alert_status == 1">已消除</span>
                        <span v-else-if="scope.row.alert_status == 2">待处理</span>
                        <span v-else-if="scope.row.alert_status == 3">已消除，待处理</span>
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[5].prop" :label="tableOption.head[5].label" :width="tableOption.head[5].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span v-if="scope.row.method == 0"></span>
                        <span v-else-if="scope.row.method == 1">邮件</span>
                        <span v-else-if="scope.row.method == 2">微信</span>
                        <span v-else-if="scope.row.method == 3">邮件，微信</span>
                        <span v-else-if="scope.row.method == 4">APP</span>
                        <span v-else-if="scope.row.method == 5">邮件，App</span>
                        <span v-else-if="scope.row.method == 6">微信，App</span>
                        <span v-else-if="scope.row.method == 7">邮件，微信，App</span>
                    </template>
                </el-table-column>
            </template>
        </mc-table>
        <mc-pager :pager-option.sync="pager" ref="notice-rule-pager" @getList="$_getTableList"></mc-pager>

        <mc-dialog :dialog-option.sync="dialog.serve">
            <template slot="content">
                <mc-layout-row label-text="站点" :labelWidth="150" important>
                    <el-autocomplete v-model="state3" style="width:100%" :fetch-suggestions="siteSearch" placeholder="请输入内容"
                        @select="handleSelect">
                        <!-- <i class="el-icon-error el-input__icon" style="cursor:pointer" v-if="state3!==''" slot="suffix" @click="handleIconClick">
                        </i> -->
                        <template slot-scope="{ item }">
                            <div class="name">{{ item.site_name }}</div>
                        </template>
                    </el-autocomplete>

                </mc-layout-row>

                <mc-layout-row label-text="人员" :labelWidth="150" important>
                    <!-- <el-select style="width:100%" placeholder="请选择" v-model="selectData.user.value">
                        <el-option v-for="item in selectData.user.list" :key="item.user_id" :value="item.user_id"
                            :label="item.username">
                        </el-option>
                    </el-select> -->
                    <el-autocomplete v-model="state4" style="width:100%" :fetch-suggestions="personSearch" placeholder="请输入内容"
                        @select="handleSelectName">
                        <template slot-scope="{ item }">
                            <div class="name">{{ item.username }}</div>
                        </template>
                    </el-autocomplete>
                </mc-layout-row>

                <mc-layout-row label-text="告警级别" :labelWidth="150" content-align-row="left" important>
                    <el-checkbox-group v-model="selectData.level.value">
                        <el-checkbox v-for="(item, index) in selectData.level.list" :key="index" :label="item.severity_id">
                            {{item.severity_name}}
                        </el-checkbox>
                    </el-checkbox-group>
                </mc-layout-row>

                <mc-layout-row label-text="告警状态" :labelWidth="150" content-align-row="left" important>
                    <el-checkbox-group v-model="selectData.state.value">
                        <el-checkbox v-for="(item, index) in selectData.state.list" :key="index" :label="item.status_id">
                            {{item.status_name}}
                        </el-checkbox>
                    </el-checkbox-group>
                </mc-layout-row>

                <mc-layout-row label-text="通知方式" :labelWidth="150" content-align-row="left" important>
                    <el-checkbox-group v-model="selectData.method.value">
                        <el-checkbox v-for="(item, index) in selectData.method.list" :key="index" :label="item.method_id">
                            {{item.method_name}}
                        </el-checkbox>
                    </el-checkbox-group>
                </mc-layout-row>

            </template>
            <template slot="footer">
                <el-button type="default" @click="dialog.serve.visible = false">取消</el-button>
                <el-button type="primary" @click="$_addNotice" :loading="dialog.serve.state.isLoading">确定</el-button>
            </template>
        </mc-dialog>

        <mc-dialog :dialog-option.sync="dialog.edit">
            <template slot="content">
                <mc-layout-row label-text="站点" :labelWidth="150" important>
                    <!-- <el-select style="width:100%" v-model="selectData.site.value">
                        <el-option v-for="item in selectData.site.list" :key="item.site_id" :value="item.site_id"
                            :label="item.site_name">
                        </el-option>
                    </el-select> -->
                    <el-autocomplete v-model="state3" :disabled="true" style="width:100%" :fetch-suggestions="siteSearch"
                        placeholder="请输入内容" @select="handleSelect">
                        <!-- <i class="el-icon-error el-input__icon" style="cursor:pointer" v-if="state3!==''" slot="suffix" @click="handleIconClick">
                        </i> -->
                        <template slot-scope="{ item }">
                            <div class="name">{{ item.site_name }}</div>
                        </template>
                    </el-autocomplete>
                </mc-layout-row>

                <mc-layout-row label-text="人员" :labelWidth="150" important>
                    <!-- <el-select style="width:100%" v-model="selectData.user.value">
                        <el-option v-for="item in selectData.user.list" :key="item.user_id" :value="item.user_id"
                            :label="item.username">
                        </el-option>
                    </el-select> -->
                    <el-autocomplete v-model="state4" :disabled="true" style="width:100%" :fetch-suggestions="personSearch"
                        placeholder="请输入内容" @select="handleSelectName">
                        <template slot-scope="{ item }">
                            <div class="name">{{ item.username }}</div>
                        </template>
                    </el-autocomplete>
                </mc-layout-row>

                <mc-layout-row label-text="告警级别" :labelWidth="150" content-align-row="left" important>
                    <el-checkbox-group v-model="selectData.level.value">
                        <el-checkbox v-for="(item, index) in selectData.level.list" :key="index" :label="item.severity_id">
                            {{item.severity_name}}
                        </el-checkbox>
                    </el-checkbox-group>
                </mc-layout-row>

                <mc-layout-row label-text="告警状态" :labelWidth="150" content-align-row="left" important>
                    <el-checkbox-group v-model="selectData.state.value">
                        <el-checkbox v-for="(item, index) in selectData.state.list" :key="index" :label="item.status_id">
                            {{item.status_name}}
                        </el-checkbox>
                    </el-checkbox-group>
                </mc-layout-row>

                <mc-layout-row label-text="通知方式" :labelWidth="150" content-align-row="left" important>
                    <el-checkbox-group v-model="selectData.method.value">
                        <el-checkbox v-for="(item, index) in selectData.method.list" :key="index" :label="item.method_id">
                            {{item.method_name}}
                        </el-checkbox>
                    </el-checkbox-group>
                </mc-layout-row>
            </template>
            <template slot="footer">
                <el-button type="default" @click="dialog.edit.visible = false">取消</el-button>
                <el-button type="primary" @click="$_editorNotice" :loading="dialog.edit.state.isLoading">确定</el-button>
            </template>
        </mc-dialog>

        <mc-dialog :dialog-option.sync="dialog.delete">
            <template slot="content">
                <mc-label icon="el-icon-error" error>删除后不可恢复，确定删除这个规则吗？</mc-label>
            </template>
        </mc-dialog>

    </div>
</template>

<script>
    export default {
        name: "admin-notice-rule",
        data() {
            return {
                searchParmas: {
                    site: '',
                    username: ''
                },
                siteValue: '',
                selectData: {
                    user: {
                        list: [],
                        value: [],
                    },
                    site: {
                        list: [],
                        value: '',
                    },
                    level: {
                        list: [],
                        value: [],
                    },
                    state: {
                        list: [],
                        value: [],
                    },
                    method: {
                        list: [],
                        value: [],
                    },
                },
                // UserList: [],
                pager: {
                    page: 1,
                    per_page: 10,
                    per_pages: [10, 20, 30, 40, 50],
                    total: 0,
                },
                tableOption: {
                    loading: false,
                    index: {
                        disable: true,
                    },
                    operations: {
                        disable: true,
                        label: "操作",
                        items: [{
                            label: "修改",
                            type: "primary",
                            size: 'mini',
                            click: (index, row) => {
                                this.dialog.edit.methods.open(row);
                            },
                        }, {
                            label: "删除",
                            type: "danger",
                            size: 'mini',
                            click: (index, row) => {
                                this.dialog.delete.methods.open(row)
                            },
                        }, ],
                    },
                    head: [{
                            prop: "site_name",
                            label: "站点名称",
                            width: "",
                        },
                        {
                            prop: "email",
                            label: "账号",
                            width: "",
                        },
                        {
                            prop: "username",
                            label: "姓名",
                            width: "100",
                        },
                        {
                            prop: "alert_severity",
                            label: "告警级别",
                            width: "150",
                        },
                        {
                            prop: "alert_status",
                            label: "告警状态",
                            width: "150",
                        },
                        {
                            prop: "method",
                            label: "通知方式",
                            width: "150",
                        },
                    ],
                    data: [],
                },
                dialog: {
                    serve: {
                        visible: false,
                        state: {
                            isLoading: false,
                        },
                        title: "新增通知规则",
                        style: {
                            showConfirm: true,
                        },
                        methods: {
                            open: (item) => {
                                for (let i in this.selectData) {
                                    this.selectData[i].value = [];
                                }
                                this.selectData.site.value = '';
                                this.selectData.user.value = '';
                                this.state3 = '';
                                this.state4 = '';
                                this.dialog.serve.visible = true;
                            },
                            confirm: () => {
                                this.$_addNotice()
                            }
                        },
                        data: {
                            text: "",
                        },
                    },
                    edit: {
                        visible: false,
                        state: {
                            isLoading: false,
                        },
                        title: "修改通知规则",
                        style: {
                            showConfirm: true,
                        },
                        methods: {
                            open: (item) => {
                                this.$_openEdit(item)
                            },
                            confirm: () => {
                                this.$_editorNotice()
                            }
                        },
                        data: {
                            row: {},
                        },
                    },
                    delete: {
                        visible: false,
                        state: {
                            isLoading: false,
                        },
                        title: "删除通知规则",
                        style: {
                            width: "400px",
                            showConfirm: true,
                        },
                        methods: {
                            open: (item) => {
                                this.dialog.delete.data.row = item;
                                this.dialog.delete.visible = true;
                            },
                            confirm: () => {
                                this.$_deleteNotice()
                            }
                        },
                        data: {
                            row: {},
                        },
                    }
                },
                state3: '',
                state4: '',
                siteList: []
            }
        },
        mounted() {
            this.$_getTableList();
            this.$_getInfoList();
            this.$_getSiteList();
            // this.$_getUser();
        },
        methods: {
            handleIconClick() {
                this.state3 = ''
            },
            handleSelect(item) {
                this.state3 = item.site_name
                this.selectData.site.value = item.site_id
            },
            handleSelectName(item) {
                this.state4 = item.username
                this.selectData.user.value = item.user_id
            },
            siteSearch(queryString, cb) {
                let siteArray = this.siteList;
                let results = queryString ? siteArray.filter(this.siteFilter(queryString)) : siteArray;
                // 调用 callback 返回建议列表的数据\
                cb(results);
            },
            personSearch(queryString, cb) {
                let personArray = this.selectData.user.list;
                let results = queryString ? personArray.filter(this.personFilter(queryString)) : personArray;
                // 调用 callback 返回建议列表的数据\
                cb(results);
            },
            siteFilter(queryString) {
                return (siteArray) => {
                    return (siteArray.site_name.toLowerCase().indexOf(queryString.toLowerCase()) > -1);
                };
            },
            personFilter(queryString) {
                return (personArray) => {
                    return (personArray.username.toLowerCase().indexOf(queryString.toLowerCase()) > -1);
                };
            },
            $_getTableList: async function () {
                this.tableOption.loading = true;
                let params = {
                    page: this.pager.page,
                    per_page: this.pager.per_page,
                    site_name: this.searchParmas.site,
                    username: this.searchParmas.username
                }
                let data = await this.$api.adminNoticeRule.getList.getNoticeRuleList.call(this, params);
                if (data !== false) {
                    this.pager.total = data.total;
                    this.tableOption.data = data.items;
                }
                this.tableOption.loading = false;
            },
            $_getInfoList: async function (item) {
                // this.$_init();
                let params = {}
                let data = await this.$api.adminNoticeRule.getList.getInfoList.call(this, params);
                if (data !== false) {
                    this.selectData.user.list = data.user;
                    this.selectData.site.list = data.site;
                    this.selectData.level.list = data.alert_severity;
                    this.selectData.state.list = data.alert_status;
                    this.selectData.method.list = data.notification_method;
                }
            },
            $_getSiteList: async function (item) {
                // this.$_init();
                let params = {}
                let data = await this.$api.adminNoticeRule.getList.getSiteList.call(this, params);
                if (data !== false) {
                    this.siteList = data
                }
            },

            // $_getUser: async function (item) {
            //     let params = {}
            //     let data = await this.$api.adminNoticeRule.getList.getUser.call(this, params);
            //     if (data !== false) {
            //         this.UserList = data;
            //     }
            // },
            $_editorNotice: async function (item) {
                if (this.selectData.level.value.length == 0) {
                    this.$message.warning("请选择告警级别.");
                    return
                }
                if (this.selectData.state.value.length == 0) {
                    this.$message.warning("请选择告警状态.");
                    return
                }
                if (this.selectData.method.value.length == 0) {
                    this.$message.warning("请选择通知方式.");
                    return
                }
                this.dialog.edit.state.isLoading = true;
                this.tableOption.loading = true;
                let params = {
                    id: this.dialog.edit.data.row.id,
                    site_id: this.selectData.site.value,
                    user_id: this.selectData.user.user_id,
                    severity_id: this.$_handleRequestData(this.selectData.level.value),
                    status_id: this.$_handleRequestData(this.selectData.state.value),
                    method_id: this.$_handleRequestData(this.selectData.method.value),
                }
                let data = await this.$api.adminNoticeRule.do.editor.call(this, params);
                if (data !== false) {
                    this.$_getTableList();
                    this.dialog.edit.state.isLoading = false;
                    this.dialog.edit.visible = false;
                    this.$message.success("修改成功.");
                }
                this.tableOption.loading = false;
            },
            $_addNotice: async function () {
                if (this.state3 == '') {
                    this.$message.warning("请选择站点.");
                    return
                }
                if (this.state4 == '') {
                    this.$message.warning("请选择人员.");
                    return
                }
                if (this.selectData.level.value.length == 0) {
                    this.$message.warning("请选择告警级别.");
                    return
                }
                if (this.selectData.state.value.length == 0) {
                    this.$message.warning("请选择告警状态.");
                    return
                }
                if (this.selectData.method.value.length == 0) {
                    this.$message.warning("请选择通知方式.");
                    return
                }
                this.dialog.serve.state.isLoading = true
                if (this.selectData.site.value == '' && this.state3 !== '') {
                    for (let i in this.siteList) {
                        if (this.siteList[i].site_name == this.state3) {
                            this.selectData.site.value = this.siteList[i].site_id
                            break
                        }
                    }
                }
                if (this.selectData.user.value == '' && this.state4 !== '') {
                    for (let i in this.selectData.user.list) {
                        if (this.selectData.user.list[i].username == this.state4) {
                            this.selectData.user.value = this.selectData.user.list[i].user_id
                            break
                        }
                    }
                }
                let params = {
                    site_id: this.selectData.site.value,
                    user_id: this.selectData.user.value,
                    severity_id: this.$_handleRequestData(this.selectData.level.value),
                    status_id: this.$_handleRequestData(this.selectData.state.value),
                    method_id: this.$_handleRequestData(this.selectData.method.value),
                }
                let data = await this.$api.adminNoticeRule.do.add.call(this, params);
                if (data !== false) {
                    this.dialog.serve.visible = false;
                    this.$_getTableList();
                    this.$message.success("添加成功.")
                }
                this.dialog.serve.state.isLoading = false;
            },
            $_deleteNotice: async function (item) {
                let params = {
                    id: this.dialog.delete.data.row.id,
                }
                let data = await this.$api.adminNoticeRule.do.delete.call(this, params);
                if (data !== false) {
                    this.dialog.delete.visible = false;
                    this.$_getTableList();
                    this.$message.success("删除成功.");
                }
            },
            $_openEdit(item) {
                this.dialog.edit.data.row = item;
                for (let i in this.selectData) {
                    this.selectData[i].value = [];
                }
                this.selectData.user.value = item.user_id;
                this.selectData.site.value = item.site_id;
                this.state3 = item.site_name;
                this.state4 = item.username;
                this.$_handleId('level', item.alert_severity)
                this.$_handleId('state', item.alert_status)
                this.$_handleId('method', item.method)
                this.dialog.edit.visible = true;
            },
            $_handleId(item, status_num) {
                switch (status_num) {
                    case '1':
                        this.selectData[item].value.push('1');
                        break;
                    case '2':
                        this.selectData[item].value.push('2')
                        break;
                    case '3':
                        this.selectData[item].value.push('1')
                        this.selectData[item].value.push('2')
                        break;
                    case '4':
                        this.selectData[item].value.push('4')
                        break;
                    case '5':
                        this.selectData[item].value.push('1')
                        this.selectData[item].value.push('4')
                        break;
                    case '6':
                        this.selectData[item].value.push('2')
                        this.selectData[item].value.push('4')
                        break;
                    case '7':
                        this.selectData[item].value.push('1')
                        this.selectData[item].value.push('2')
                        this.selectData[item].value.push('4')
                        break;
                }
            },
            $_handleRequestData(arr) {
                let result = 0;
                arr.map(item => {
                    result += (item - 0);
                })
                return result + '';
            },
            $_handleChoose(id, item) {
                let i = this.selectData.value[item].length
                if (i > this.selectData.length[item]) {
                    this.selectData.choose[item] += parseInt(id);
                    this.selectData.length[item]++;
                } else if (i < this.selectData.length[item]) {
                    this.selectData.choose[item] -= parseInt(id);
                    this.selectData.length[item]--;
                }
            },
            $_reset() {
                this.searchParmas.site = '';
                this.searchParmas.username = '';
                this.$_getTableList();
            }
        },
        watch: {
            pager: {
                deep: true,
                handler: function () {
                    this.$_getTableList();
                },
            },
        }
    }
</script>

<style lang="less" scoped>
    .notice-rule {
        .mc-search-bar {
            // width: 100%;
            height: 100%;
            display: flex;

            .mc-search-bar-input {
                margin-right: 10px;
                display: inline-flex;
            }

            .mc-search-bar-btn {
                height: 40px;
            }
        }

        .el-dialog {

            .require {
                color: red
            }

            .site-item {
                display: inline-flex;
                align-items: center;
                width: 100%;
                margin-bottom: 20px;

                label {
                    width: 100px;
                    text-align: right;
                }

                .site-input {
                    flex: 1;
                    padding-left: 10px;

                    label {
                        text-align: left;
                        margin-left: 0;
                    }
                }
            }
        }
    }
</style>